// extracted by mini-css-extract-plugin
export default {"fullWidth":"Um-z","image":"Vm-z","lazyLoadPicture":"Wm-z","lazyLoadSpinner":"Xm-z","lazyLoadSpin":"Ym-z","lazyLoadImage":"Zm-z","hasStyledAspectRatio":"_m-z"};